import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";
import { ParagraphLarge } from "styles/elements/Texts";
import { CssButton, CssFlex, CssGrid } from "styles/helpers/layout";

export const StyledModuleCard = styled(CssGrid)<Props>`
  width: 21rem;
  min-height: 21rem;
  border-radius: 16px;
  grid-template-rows: 1fr auto;
  gap: 1rem;
  padding: 1rem;
  border: solid 1px;
  border-color: ${(props: Props) => props.theme.palette.neutral._800};
  background: ${(props: Props) => props.theme.palette.neutral.white};

  cursor: pointer;
  &:hover {
    transition: all 0.2s ease-in-out;
    box-shadow: 0px 11px 27px 0px rgba(84, 84, 84, 0.2);
  }

  hr {
    border: 0;
    margin: 0;
    width: 100%;
    height: 1px;
    background: ${(props: Props) => props.theme.palette.neutral._800};
  }

  ${ParagraphLarge} {
    font-size: ${(props: Props) => props.theme.font.size._14};
    color: ${(props: Props) => props.theme.palette.neutral._300};

    * {
      all: revert;
      margin-top: 0;
    }
  }

  ${CssButton} {
    border-radius: 8px;
    padding: 0.3rem 1.5rem;
    font-weight: 400;
  }
`;

export const StyledIconContainer = styled(CssFlex)<Props>`
  width: 9rem;
  height: 9rem;
  background-color: #FFB7AC;
  border-radius: 50%;
  border: solid ${(props: Props) => props.theme.font.size._10} ${(props: Props) => props.theme.palette.neutral._900};
`;
